import Backbone from 'backbone';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BackboneViewProps } from '../../types';
import { Snowflake } from './Snowflake';
import { defaultQueryClient } from '../../query_client';
import { SnowflakeProvider } from './contexts/SnowflakeContext';

const template = require('./index.pug');

export default (Backbone as any).Epoxy.View.extend({
  initialize(options: BackboneViewProps) {
    this.tenant = options.tenant;
    this.integration = 'snowflake';
    requestAnimationFrame(() => {
      this.render();
      this.renderSnowflakeIntegrationComponent();
    });
  },

  getActiveTabName(): string {
    const splitUrl = window.location.href.split('/');
    const lastItem = splitUrl[splitUrl.length - 1];
    if (lastItem === '') {
      return 'overview';
    }
    return lastItem;
  },

  toggleView(tenant: string, integration: string) {
    return (tabName: string) => {
      Backbone.history.navigate(
        `/org/${tenant}/integrations/${integration}/${tabName}`
      );
    };
  },

  renderSnowflakeIntegrationComponent() {
    const containerDomElement = $('#SnowflakeComponentContainer')[0];
    if (containerDomElement) {
      ReactDOM.render(
        <QueryClientProvider client={defaultQueryClient}>
          <SnowflakeProvider tenant={this.tenant}>
            <Snowflake />
          </SnowflakeProvider>
        </QueryClientProvider>,
        containerDomElement
      );
    }
  },

  render() {
    this.$el.empty();
    const html = template();
    this.$el.html(html);
  },
});
